var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWestVirginia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.997,65.742c-2.996,0-17.977,12.982-22.097,12.484c-4.122-0.5-10.116-3.871-10.116-3.871l-8.988,13.86l-6.744,0.375 l-14.231,19.474l-7.492-32.959l-50.566,6.742L107.15,23.538l-8.49,3.996l5.995,10.989c0,0-1.5,39.954-2.002,45.447 c-0.276,3.063-6.768,11.406-12.457,18.19c-4.513,5.378-8.518,9.776-8.518,9.776l-8.989-0.498l-14.984,22.973l4.994,8.99 l-6.494,5.991c0,0-3.492-5.49-8.485-5.49c-4.998,0-5.496,27.467-5.496,27.467l-3.995,1.498l-2.496,11.486l-11.504,4.68l2.514,15.808 c0,0,6.04,9.271,13.69,18.431c7.232,8.657,15.896,17.222,22.267,17.768c0,0,14.236,22.475,22.849,19.663 c8.615-2.807,11.984-9.708,11.984-9.708s14.983,4.334,19.105,0c4.119-4.338,7.117-15.201,7.117-15.201l7.489,4.122l10.49-7.49 c0,0,7.118,2.62,9.739-4.496s0-13.109,0-13.109s11.728-23.901,18.137-43.044c2.749-8.217,4.524-15.562,3.962-19.758 c0,0,7.492,6.99,16.107,7.74s8.615-7.115,9.363-15.731c0.09-1.046,0.162-1.983,0.21-2.841c0.369-6.197-0.21-7.648-0.21-7.648 s8.616,1.499,12.735-3.743c4.122-5.246,18.354-24.35,18.354-26.969c0-2.623,0-19.105,0-19.105l28.093,14.609l4.493-17.607 C262.719,80.721,240.996,65.742,237.997,65.742z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWestVirginia);
export default __webpack_public_path__ + "static/media/westVirginia.1deccebc55ae537f0b60fc41125a2ce4.svg";
export { ForwardRef as ReactComponent };